import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./store/reducers";
import rootSaga from "./store/sagas";
import App from "./pages";
import "./styles/styles.scss";
import "react-datepicker/dist/react-datepicker.css";
import "regenerator-runtime/runtime";
import "./translations/i18n";
import { createTheme, ThemeProvider } from '@mui/material/styles';


const composeEnhancers =
  (process.env.NODE_ENV !== "production" &&
    typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const sagaMiddleware = createSagaMiddleware();
const middlewares = [applyMiddleware(sagaMiddleware)];
const store = createStore(rootReducer, composeEnhancers(...middlewares));

// App

const theme = createTheme({
  typography: {
    button: {
      textTransform: "none"
    }
  }
});

const app = (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <Router>
        <App />
      </Router>
    </ThemeProvider>
  </Provider>
);

sagaMiddleware.run(rootSaga);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(app);
